/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ITreatmentDeliveryPlan } from 'app/shared/model/treatment-delivery-plan.model';
import { ITreatmentCycle } from 'app/shared/model/treatment-cycle.model';
import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';

export interface ITreatmentAssessment {
  id?: string;
  assessmentDate?: number | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  plan?: ITreatmentDeliveryPlan | null;
  cycle?: ITreatmentCycle | null;
  assessmentType?: IClinicalDictionary | null;
  assessmentResult?: IClinicalDictionary | null;
}

export const defaultValue: Readonly<ITreatmentAssessment> = {
  active: false,
};
